import { initializeApp, getApps, getApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyC1QbCj4lQwXJ0J8qX9q3XQ4Q5XxXxXxXx",
  authDomain: "femsa-canal-coca-cola.firebaseapp.com",
  databaseURL: "https://femsa-canal-coca-cola-default-rtdb.firebaseio.com",
  projectId: "femsa-canal-coca-cola",
  storageBucket: "femsa-canal-coca-cola.appspot.com",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abcdef123456"
};

// Inicializar Firebase solo si no existe una aplicación ya inicializada
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Inicializar Realtime Database
export const database = getDatabase(app);
